import React, { useState } from 'react';
import CalcShell from '../CalcShell';

const NUMERALS = [
  ['M',1000],['CM',900],['D',500],['CD',400],['C',100],['XC',90],
  ['L',50],['XL',40],['X',10],['IX',9],['V',5],['IV',4],['I',1]
];
function toRoman(n) {
  if (!Number.isFinite(n) || n <= 0) return '';
  let out = ''; for (const [s,v] of NUMERALS) { while (n >= v) { out += s; n -= v; } } return out;
}

export default function RomanNumeralDateCalc() {
  const today = new Date();
  const [d, setD] = useState(today.getDate());
  const [m, setM] = useState(today.getMonth() + 1);
  const [y, setY] = useState(today.getFullYear());
  const [sep, setSep] = useState('•');

  const day = toRoman(d);
  const month = toRoman(m);
  const year = toRoman(y);

  return (
    <CalcShell look="cnet" title="Roman Numeral Date Converter" subtitle="Convert any date to a Roman-numeral rendering used in monuments, movies and copyright lines.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="grid grid-cols-3 gap-3">
            <div className="field"><label>Day</label><input type="number" min={1} max={31} value={d} onChange={e => setD(e.target.value)} data-testid="rd-day"/></div>
            <div className="field"><label>Month</label><input type="number" min={1} max={12} value={m} onChange={e => setM(e.target.value)} data-testid="rd-month"/></div>
            <div className="field"><label>Year</label><input type="number" value={y} onChange={e => setY(e.target.value)} data-testid="rd-year"/></div>
          </div>
          <div className="field"><label>Separator</label>
            <select value={sep} onChange={e => setSep(e.target.value)}>
              <option value="•">Dot ( • )</option>
              <option value="/">Slash ( / )</option>
              <option value=" ">Space</option>
              <option value="-">Hyphen ( - )</option>
            </select>
          </div>
        </div>
        <div>
          <div className="p-6 rounded-xl bg-slate-900 text-amber-300 text-center">
            <div className="text-xs text-slate-400 mb-2">Roman Date</div>
            <div className="text-4xl font-serif tracking-widest" data-testid="rd-result">{day}{sep}{month}{sep}{year}</div>
          </div>
          <table className="data-table mt-4">
            <tbody>
              <tr><td>Day</td><td className="text-right">{d} → <b>{day}</b></td></tr>
              <tr><td>Month</td><td className="text-right">{m} → <b>{month}</b></td></tr>
              <tr><td>Year</td><td className="text-right">{y} → <b>{year}</b></td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </CalcShell>
  );
}
